'use strict';

exports.maybeToPrecision = function maybeToPrecision(value, digits) {
    if (digits) return value.toPrecision(digits);
    else return value.toString();
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/ml-regression/src/regression/util.js
 ** module id = 38
 ** module chunks = 0
 **/